import React from 'react';
import { H1 } from '../../../__core/Styles/Headings/Headings';
import { useTranslation } from 'react-i18next';
import { CoursesListItemStyle, NoItemsStyle } from '../Styles/Styles';
import AppConfig from '../../../Configs/AppConfig';
import { AppConfigType } from '../../../Configs/AppConfigType';

const NoItems: React.FunctionComponent = (): React.ReactElement => {
  const { t } = useTranslation();
  const { COURSES_CATALOG_URL = '', CONTACT_URL = '' } =
    AppConfig as AppConfigType;

  return (
    <CoursesListItemStyle>
      <NoItemsStyle>
        <H1>{t('Welcome')}</H1>
        {COURSES_CATALOG_URL ? (
          <>
            <p>{t('Currently you are not assigned to any course.')}</p>
            <p>
              {t('To access the course')}{' '}
              {!CONTACT_URL ? (
                t('contact your course specialist')
              ) : (
                <a href={CONTACT_URL} target="_blank" rel="noreferrer">
                  {t('contact your course specialist')}
                </a>
              )}{' '}
              {t('or find a course for yourself in the')}{' '}
              <a href={COURSES_CATALOG_URL} target="_blank" rel="noreferrer">
                {t('Course Offer.')}
              </a>
            </p>
          </>
        ) : (
          <p>
            {t(
              'Currently you are not assigned to any course. Please contact course specialist.'
            )}
          </p>
        )}
      </NoItemsStyle>
    </CoursesListItemStyle>
  );
};

export default NoItems;
